import { DatePicker } from '@3plearning/react-components';
import {
    ACTIVITY_MASTERY,
    LIVE_MATHS,
    PARTICIPATION,
    SKILL_QUESTS_MASTERY
} from '../components/report-filters/filter-constants';

/* App routes */

export const ACTIVITY_MASTERY_PATH = '/activity-mastery';
export const PARTICIPATION_PATH = '/participation';
export const LIVE_MATHS_PATH = '/live-mathletics';
export const SKILL_QUESTS_MASTERY_PATH = '/skills-quest-mastery';

export const REPORT_TYPE_TO_PATH_MAP = {
    [ACTIVITY_MASTERY]: ACTIVITY_MASTERY_PATH,
    [PARTICIPATION]: PARTICIPATION_PATH,
    [LIVE_MATHS]: LIVE_MATHS_PATH,
    [SKILL_QUESTS_MASTERY]: SKILL_QUESTS_MASTERY_PATH
};

export const YEAR_GROUP_PATH = 'year';
export const TEACHER_PATH = 'teacher';
export const CLASS_PATH = 'class';
export const GROUP_PATH = 'group';
export const STUDENT_PATH = 'student';

/* Date query params */

export const DATE_TYPE = 'dateType';
export const START_DATE = 'startDate';
export const END_DATE = 'endDate';
export const DATE_PARAMS = [DATE_TYPE, START_DATE, END_DATE];

export const DATE_TYPE_MAP = {
    [DatePicker.THIS_WEEK]: 0,
    [DatePicker.LAST_WEEK]: 1,
    [DatePicker.THIS_SCHOOL_YEAR]: 2,
    [DatePicker.CUSTOM_DATE]: 3,
    [DatePicker.LIFETIME]: 4
};

export const DATE_PARAM_MAP = {
    0: DatePicker.THIS_WEEK,
    1: DatePicker.LAST_WEEK,
    2: DatePicker.THIS_SCHOOL_YEAR,
    3: DatePicker.CUSTOM_DATE,
    4: DatePicker.LIFETIME
};

/* API endpoints */

export const ENDPOINT_PATH_ACTIVITY_MASTERY = 'activity-mastery';
export const ENDPOINT_PATH_PARTICIPATION = 'participation';
export const ENDPOINT_PATH_LIVE_MATHS = 'livemaths';
export const ENDPOINT_PATH_SKILL_QUESTS_MASTERY = 'skill-mastery';

export const ENDPOINT_PATH_THIS_WEEK = 'this-week';
export const ENDPOINT_PATH_LAST_WEEK = 'last-week';
export const ENDPOINT_PATH_THIS_SCHOOL_YEAR = 'this-academic-year';
export const ENDPOINT_PATH_CUSTOM_DATE = 'custom-date';
export const ENDPOINT_PATH_LIFETIME = 'lifetime';

export const ENDPOINT_PATH_ALL_YEARS = 'all';
export const ENDPOINT_PATH_ALL_TEACHERS = 0;

export const DATE_OPTION_TO_PATH_MAP = {
    [DatePicker.THIS_WEEK]: ENDPOINT_PATH_THIS_WEEK,
    [DatePicker.LAST_WEEK]: ENDPOINT_PATH_LAST_WEEK,
    [DatePicker.THIS_SCHOOL_YEAR]: ENDPOINT_PATH_THIS_SCHOOL_YEAR,
    [DatePicker.CUSTOM_DATE]: ENDPOINT_PATH_CUSTOM_DATE,
    [DatePicker.LIFETIME]: ENDPOINT_PATH_LIFETIME
};

export const REPORT_FORMATS = {
    CSV_REPORT: 1,
    PDF_REPORT: 2
};

export const PORTAL_MODULE = {
    MANAGE_STUDENTS: 'StudentsManagementModuleId',
    ASSIGN_REVIEW: 'AssignReviewModuleId'
};

export const CONFIGURATION_KEYS = {
    SHOW_ACCURACY_OVERVIEW_GRAPH: 'showAccuracyOverviewGraph',
    MAX_CERTIFICATES_CAN_DOWNLOAD: 'maxCertificatesCanDownload'
};

export const MATHLETICS_ID = 1;
export const TOTAL_CERTIFICATES_TYPE = 0;



// WEBPACK FOOTER //
// ./helpers/constants.js